import { useEffect, useState } from 'react'

/**
 * Apariencia clara (la del dashboard ChileSST) por defecto; «Black» queda como
 * preferencia explícita. La clave es nueva a propósito: la anterior se escribía
 * en cada carga aunque nadie la eligiera, así que no distingue una preferencia
 * real de un valor por omisión.
 */
const CLAVE = 'chilesst.apariencia'

export function SelectorDeApariencia() {
  const [claro, setClaro] = useState(() => {
    try { return localStorage.getItem(CLAVE) !== 'black' } catch { return true }
  })
  useEffect(() => {
    document.documentElement.dataset.apariencia = claro ? 'claro' : 'black'
  }, [claro])
  function alternar(): void {
    const siguiente = !claro
    try { localStorage.setItem(CLAVE, siguiente ? 'claro' : 'black') } catch { /* Preferencia opcional. */ }
    setClaro(siguiente)
  }
  return <button type="button" aria-label={claro ? 'Activar modo Black' : 'Activar modo claro'} aria-pressed={!claro}
    title={claro ? 'Modo Black' : 'Modo claro'}
    className="sst-boton-icono"
    onClick={alternar}>
    {claro
      ? <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" /></svg>
      : <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>}
  </button>
}
